const initialValues = (loanAccount) => ({
  date: new Date(),
  loanAccount,
  amount: undefined,
});

export default initialValues;
